<template>
  <v-container v-if="!isAdmin">
    <p>Non admin user can't acces to this page.</p>
  </v-container>
  <v-container v-else>
    <v-stepper v-model="e6" vertical>
      <h1>Ajouter un bien</h1>
      <v-stepper-step :complete="e6 > 1" step="1" @click="e6 = 1">
        Nom du bien
        <small>Summarize if needed</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-text-field label="Name" v-model="name"></v-text-field>
        <v-text-field
          label="Localisation"
          v-model="localisation"
        ></v-text-field>
        <v-text-field label="Surface" v-model="surface"></v-text-field>
        <v-btn color="primary" @click="e6 = 2">Continue</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 2" step="2" @click="e6 = 2"
        >Properties</v-stepper-step
      >

      <v-stepper-content step="2">
        <v-select
          v-model="selectedType"
          :items="type"
          item-text="name"
          item-value="id"
          chips
          :menu-props="{ maxHeight: '400' }"
          label="type"
          multiple
        ></v-select>
        <v-select
          v-model="selectedUsage"
          :items="usage"
          item-text="name"
          item-value="id"
          chips
          :menu-props="{ maxHeight: '400' }"
          label="usage"
          multiple
        ></v-select>
        <v-select
          v-model="selectedEnvironnement"
          :items="environnement"
          item-text="name"
          item-value="id"
          chips
          :menu-props="{ maxHeight: '400' }"
          label="environnement"
          multiple
        ></v-select>
        <v-select
          v-model="selectedEtat"
          :items="etat"
          item-text="name"
          item-value="id"
          chips
          :menu-props="{ maxHeight: '400' }"
          label="etat"
          multiple
        ></v-select>
        <v-select
          v-model="selectedStyle"
          :items="style"
          item-text="name"
          item-value="id"
          chips
          :menu-props="{ maxHeight: '400' }"
          label="style"
          multiple
        ></v-select>
        <v-btn color="primary" @click="e6 = 3">Continue</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 3" step="3" @click="e6 = 3"
        >Loyer</v-stepper-step
      >

      <v-stepper-content step="3">
        <v-text-field
          label="loyer mensuel"
          v-model="loyerMensuel"
        ></v-text-field>
        <v-text-field label="loyer annuel" v-model="loyerAnnuel"></v-text-field>
        <p>Laisser vide si non.</p>
        <v-btn color="primary" @click="e6 = 4">Continue</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 4" step="4" @click="e6 = 4"
        >Descriptions</v-stepper-step
      >
      <v-stepper-content step="4">
        <v-textarea
          name="input-7-1"
          label="searchdescription"
          v-model="searchDescription"
          hint="Hint text"
        ></v-textarea>
        <v-textarea
          name="input-7-1"
          label="description"
          v-model="description"
          hint="Hint text"
        ></v-textarea>
        <v-btn color="primary" @click="e6 = 5">Continue</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 5" step="5" @click="e6 = 5"
        >Contrat</v-stepper-step
      >
      <v-stepper-content step="5">
        <v-textarea
          name="input-7-1"
          label="Contrat disponible"
          v-model="contrat"
          hint="Hint text"
        ></v-textarea>
        <v-btn color="primary" @click="e6 = 6">Continue</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 6" step="6" @click="e6 = 6"
        >Contraintes</v-stepper-step
      >
      <v-stepper-content step="6">
        <v-textarea
          name="input-7-1"
          label="Contraintes particulières"
          v-model="contraintes"
          hint="Hint text"
        ></v-textarea>
        <v-btn color="primary" @click="e6 = e6 + 1">Continue</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>

      <v-stepper-step step="7" :complete="e6 > 7" @click="e6 = 7"
        >Photos</v-stepper-step
      >
      <v-stepper-content step="7">
        <v-file-input
          multiple
          v-model="images"
          accept="image/*"
          label="Photos"
        ></v-file-input>
        <v-btn color="primary" @click="e6 = e6 + 1">Continue</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>

      <v-stepper-step :complete="published" step="8" @click="e6 = 8"
        >Sauvegarder</v-stepper-step
      >
      <v-stepper-content step="8">
        <v-btn color="success" @click="publish">Sauvegarder</v-btn>
        <v-btn text @click="e6 = e6 - 1">Previous</v-btn>
      </v-stepper-content>
    </v-stepper>
    <v-content>
      <v-row>
        <v-col v-for="(bien, i) in getBiens" :key="i" link cols="6">
          <BienCard :bien="bien" :fetch="fetchAll" />
        </v-col>
      </v-row>
    </v-content>
  </v-container>
</template>

<script>
import BienCard from "../components/AddBiens/BienCard";
import { publishBien } from "@/services/biens";
import { mapGetters, mapActions } from "vuex";

let datajson = require("../assets/json/data.json");
export default {
  components: {
    BienCard
  },
  data() {
    return {
      loading: true,
      admin: false,
      e6: 1,
      type: undefined,
      selectedType: [],
      usage: undefined,
      selectedUsage: [],
      environnement: undefined,
      selectedEnvironnement: [],
      etat: undefined,
      selectedEtat: [],
      style: undefined,
      selectedStyle: [],

      name: "",
      localisation: "",
      surface: "",
      loyerMensuel: "",
      loyerAnnuel: "",
      searchDescription: "",
      description: "",
      contrat: "",
      contraintes: "",
      images: undefined,
      published: false
    };
  },

  methods: {
    ...mapActions({
      notify: "notificationModule/notify",
      fetchAll: "biensModule/fetchAll"
    }),
    isValid(bien) {
      // name
      if (!bien.name) {
        this.notify({
          content: "Veuillez remplir le champ name.",
          color: "ERROR"
        });
        return false;
      }

      // localisation
      if (!bien.localisation) {
        this.notify({
          content: "Veuillez remplir le champ localisation.",
          color: "ERROR"
        });
        return false;
      }

      // surface
      if (!bien.surface) {
        this.notify({
          content: "Veuillez remplir le champ surface.",
          color: "ERROR"
        });
        return false;
      }

      // loyer mensuel
      if (!bien.loyer_mensuel) {
        this.notify({
          content: "Veuillez remplir le champ loyer mensuel.",
          color: "ERROR"
        });
        return false;
      }

      // search description
      if (!bien.search_description) {
        this.notify({
          content: "Veuillez remplir le champ search description.",
          color: "ERROR"
        });
        return false;
      }

      // description
      if (!bien.description) {
        this.notify({
          content: "Veuillez remplir le champ description.",
          color: "ERROR"
        });
        return false;
      }

      // contrat
      if (!bien.contrat) {
        this.notify({
          content: "Veuillez remplir le champ contrat.",
          color: "ERROR"
        });
        return false;
      }

      // contrat
      if (!bien.contraintes) {
        this.notify({
          content: "Veuillez remplir le champ contraintes.",
          color: "ERROR"
        });
        return false;
      }

      // else
      return true;
    },
    publish() {
      let newBien = {};
      if (this.name) newBien.name = this.name;
      if (this.localisation) newBien.localisation = this.localisation;
      if (this.surface) newBien.surface = this.surface;
      if (this.loyerMensuel) newBien.loyer_mensuel = this.loyerMensuel;
      if (this.loyerAnnuel) newBien.loyer_annuel = this.loyerAnnuel;
      if (this.searchDescription)
        newBien.search_description = this.searchDescription;
      if (this.description) newBien.description = this.description;
      if (this.contrat) newBien.contrat = this.contrat;
      if (this.contraintes) newBien.contraintes = this.contraintes;

      newBien.properties = [
        ...this.selectedType,
        ...this.selectedUsage,
        ...this.selectedEnvironnement,
        ...this.selectedEtat,
        ...this.selectedStyle
      ];

      // if (!this.isValid(newBien)) return;

      publishBien(newBien, this.images).then(() => {
        this.notify({
          content: "Le bien a été ajouté avec succès.",
          color: "SUCCESS"
        });
        this.published = true;
        this.fetchAll().then(() => {
          this.getBiens.forEach(element => {
            console.log(element);
          });
        });
      });
    }
  },

  computed: {
    ...mapGetters({
      getBiens: "biensModule/getBiens",
      isAdmin: "userModule/isAdmin"
    })
  },

  beforeMount() {
    this.type = datajson.type;
    this.usage = datajson.usage;
    this.environnement = datajson.environnement;
    this.etat = datajson.etat;
    this.style = datajson.style;
    this.loading = false;
    this.admin = true;
    this.fetchAll().then(() => {
      this.getBiens.forEach(element => {
        console.log(element);
      });
    });
  }
};
</script>
